import {
  AddModelToCartAction,
  ADD_MODEL_TO_CART,
  CreateNewCartAction,
  CREATE_NEW_CART,
  DELETE_MODEL_FROM_CART,
  GET_CARTS_FOR_USER,
  RemoveModelFromCartAction,
  FavoriteActionsTypes,
  Cart,
  GET_CARTS_FOR_USER_SUCCESS,
  UPDATE_CART,
} from "./types";

export const getCartsForUser = () => ({
  type: GET_CARTS_FOR_USER,
});

export const createCart = (data: any): CreateNewCartAction => ({
  type: CREATE_NEW_CART,
  payload: data,
});

export const addModelToCart = (
  cart: string,
  model: string
): AddModelToCartAction => ({
  type: ADD_MODEL_TO_CART,
  payload: {
    cart,
    model,
  },
});

export const removeModelFromCart = (
  cart: string,
  model: string
): RemoveModelFromCartAction => ({
  type: DELETE_MODEL_FROM_CART,
  payload: {
    cart,
    model,
  },
});

export const setCarts = (carts: Cart[]): FavoriteActionsTypes => ({
  type: GET_CARTS_FOR_USER_SUCCESS,
  payload: carts,
});

export const updateCart = (cart: Cart): FavoriteActionsTypes => ({
  type: UPDATE_CART,
  payload: cart,
});

// export const deleteFavoritesList = (data: any) => ({
//   type: DELETE_FAVORITES_LIST,
//   payload: data,
// });

// export const edit = (data: any) => ({
//   type: EDIT_FAVORITES_LIST,
//   payload: data,
// });
